export default {
  report: {
    title: 'Nos orientations pour le patrimoine de votre enfant',
    ReportBudget: {
      barchart: {
        title: 'Synthèse du budget de votre enfant',
      },
      title: 'Le budget de votre enfant',
    },
    ReportPatrimony: {
      title: 'Le patrimoine de votre enfant',
      patrimonyRepartitionV2: {
        graph1: 'Répartition du patrimoine de votre enfant',
        graph2:
          'Répartition du patrimoine financier de votre enfant (par catégorie)',
        title: 'Synthèse du patrimoine de votre enfant',
      },
    },
    ReportQualification: {
      title: 'La qualification retenue pour votre enfant',
      sectionPi: {
        title: "Le profil d'investisseur",
        text: "Vous avez choisi un profil d'investisseur <b>{investorProfile}</b> pour votre enfant.",
      },
      sectionEsg: {
        title: 'Le profil de durabilité',
      },
      sectionQce: {
        title:
          "Le niveau de connaissances et d'expérience en matière de produits financiers",
      },
    },
    ReportProject: {
      details: {
        yourBorrowingCapacity:
          "La capacité d'épargne mensuelle de votre enfant est de",
      },
      sections: {
        adequationReport: {
          message: {
            text1:
              "Dans le cadre du projet pour votre enfant, nous vous informons que les placements financiers proposés dans nos préconisations répondent bien à l'objectif ",
            text3: 'et du niveau de connaissances et expérience ',
          },
          preferences: {
            1: {
              title:
                "L'analyse du profil de durabilité de votre enfant requiert :",
            },
          },
          text2:
            "Grâce aux conseils délivrés ci-dessus, le niveau de risque du patrimoine financier de votre enfant s'approche de celui qui correspond au profil d'investisseur retenu.",
        },
        yourProject: {
          title: 'Le projet pour votre enfant',
          dmp: {
            item: '{amount} prélevé sur le compte {account}',
            hasRefusedAdvice: "Vous ne souhaitez pas investir aujourd'hui sur les placements que nous vous avons proposés en tenant compte du projet pour votre enfant, du profil investisseur, de niveau de connaissances et expérience des placements financiers, des préférences de durabilité et de l'horizon de placement retenu.",
            presentation: {
              text1: 'Vous avez pour projet pour votre enfant ',
            },
          },
        },
      },
      title: {
        standard: 'Le projet pour votre enfant et nos préconisations',
        isOffBoard: 'Les placements pour votre enfant',
      },
    },
    ReportReallocation: {
      title: 'Le projet pour votre enfant et nos préconisations',
    },
    ReportRGPD: {
      text2:
        'De manière générale, vous pouvez à tout moment, dans les conditions prévues par la réglementation, accéder aux données personnelles vous concernant, ainsi qu’à celles du mineur dont vous êtes le représentant légal (ci-après « le Mineur »), les faire rectifier, demander leur effacement, la limitation de leur traitement, leur portabilité ou communiquer des instructions sur le sort de vos données et de celles du Mineur en cas de décès. Le cas échéant, vous pouvez également retirer, à tout moment, votre consentement sans porter atteinte à la licéité du traitement fondé sur le consentement effectué avant le retrait de celui-ci. Vous pouvez enfin vous opposer au traitement de vos données et de celles du Mineur pour des motifs tenant à votre situation particulière, lorsque le traitement repose sur l’intérêt légitime de LCL, et vous opposer, sans motif, à l’utilisation de vos données personnelles à des fins de prospection commerciale par LCL ou par des tiers auxquels LCL aurait transmis les données le cas échéant, et ce, sous réserve de l’obtention de votre consentement préalable et/ou de l’exercice de votre droit d’opposition le cas échéant, étant précisé que le Mineur ne sera jamais sollicité à des fins de prospection commerciale.',
      text5a:
        'Pour en savoir plus sur la protection de vos données à caractère personnel et de celles du Mineur, vous pouvez consulter la Politique de Protection des Données Personnelles de LCL, incluse dans les Dispositions Générales de Banque ou, pour les Entreprises, dans la Convention de Compte, et disponible à l’adresse suivante : ',
    },
    ReportSituation: {
      titleAlt: 'La situation de votre enfant',
      yourRelatives: '',
    },
    ReportSummaryBlock: {
      titleSection: 'Impact prévisionnel sur le patrimoine de votre enfant',
    },
  },
}
